export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7595.4ca8a08a.jpg";